import React from "react";
import PropTypes from "prop-types";
import { Grow, Box, Typography } from "@material-ui/core";
import {
	WarningOutlined,
	ErrorOutline,
	CheckCircleOutline,
} from "@material-ui/icons";

const COLORS = {
	success: {
		borderColor: "#4caf50",
		textColor: "#4caf50",
		backgroundColor: "#e8f5e9",
	},
	warning: {
		borderColor: "#ff9800",
		textColor: "#ff9800",
		backgroundColor: "#fff3e0",
	},
	danger: {
		borderColor: "#C4455B",
		textColor: "#C4455B",
		backgroundColor: "#ffebee",
	},
};

const ICONS = {
	success: <CheckCircleOutline />,
	warning: <WarningOutlined />,
	danger: <ErrorOutline />,
};

export const InfoPanel = ({ showTransition, severity, message, style }) => {
	const { borderColor, textColor, backgroundColor } = COLORS[severity] || {};
	const icon = ICONS[severity] || null;

	return (
		<Grow in={showTransition} timeout={{ enter: 300, exit: 300 }} unmountOnExit>
			<Box
				display="flex"
				alignItems="center"
				border={`1px solid ${borderColor}`}
				borderRadius={4}
				p={1}
				mt={1}
				bgcolor={backgroundColor}
				style={style}
			>
				{icon && (
					<Box mr={1} color={textColor} display="flex" alignItems="center">
						{icon}
					</Box>
				)}
				<Typography
					variant="body2"
					style={{ color: textColor, display: "inline-block" }}
				>
					{message}
				</Typography>
			</Box>
		</Grow>
	);
};

InfoPanel.propTypes = {
	showTransition: PropTypes.bool.isRequired,
	severity: PropTypes.oneOf(["success", "warning", "danger"]).isRequired,
	message: PropTypes.string.isRequired,
};

InfoPanel.defaultProps = {
	showTransition: false,
	severity: "success",
	message: "",
};
